/**
 * Tâche 1438 (Eric 2026-10-02) — Déclarer au serveur un refus décidé DANS LE
 * NAVIGATEUR.
 *
 * Le rejet le plus fréquent a lieu avant tout envoi (liste blanche
 * d'extensions) : sans cet appel, ces refus n'atteindraient jamais le serveur
 * et la sonde manquerait justement le cas le plus courant.
 *
 * ⚠️ Un SEUL point d'appel, parce que TROIS écrans refusent dans le navigateur
 * (`TextDocsBulkImportZone`, `UploadTextPage` et, depuis la tâche 1451,
 * `UploadPage` pour les vidéos). N'en instrumenter qu'un donnerait un journal
 * qui a l'air complet et qui ne l'est pas — ce serait pire que pas de journal,
 * puisqu'on en tirerait des conclusions fausses.
 *
 * ⚠️ Une sonde ne bloque jamais un import : l'échec est avalé.
 */
import axios from "axios";

export async function signalerRefusNavigateur(fichiers, motif, kind = "document") {
  const API = process.env.REACT_APP_BACKEND_URL;
  await Promise.all((fichiers || []).map((f) => {
    const nom = f?.name || "";
    return axios.post(`${API}/api/import-refusals`, {
      filename: nom,
      extension: nom.includes(".") ? `.${nom.split(".").pop().toLowerCase()}` : "",
      size_bytes: f?.size,
      message: motif,
      kind,
    }, { withCredentials: true }).catch(() => null);
  }));
}

export default signalerRefusNavigateur;
